import React, { useState, useEffect, useRef } from "react";
import Logo from "../../assets/images/logo.png";
import Avatar from "@mui/material/Avatar";
import picLogo from "../../assets/images/circular_logo.svg";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/AuthContext";
import "./index.css";

const BotHeader = ({
  handleLanuageClick,
  information,
  showScroller = false,
}) => {
  const navigate = useNavigate();
  // const name = sessionStorage.getItem("name");
  // const email = sessionStorage.getItem("email");
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguageCode, setSelectedLanguageCode] = useState("en");
  const [isDropupOpen, setIsDropupOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    console.log("user", user);
  }, []);

  const languages = [
    { language: "English", languageCode: "en" },
    // { language: "Bengali", languageCode: "bn" },
    // { language: "Gujarati", languageCode: "gu" },
    { language: "Hindi", languageCode: "hi" },
    // { language: "Kannada", languageCode: "kn" },
    // { language: "Malayalam", languageCode: "ml" },
    // { language: "Marathi", languageCode: "mr" },
    // { language: "Odia (Oriya)", languageCode: "or" },
    // { language: "Punjabi", languageCode: "pa" },
    // { language: "Tamil", languageCode: "ta" },
    // { language: "Telugu", languageCode: "te" },
  ];

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSignOut = () => {
    // sessionStorage.removeItem("email");
    // sessionStorage.removeItem("name");
    // sessionStorage.removeItem("userId");
    logout();
    navigate("/");
  };

  const handleHeaderLanguage = (code) => {
    setIsDropupOpen(false);
    setSelectedLanguageCode(code);
    handleLanuageClick(code);
  };

  return (
    <>
      <div className="flex items-center pr-4 h-[40px] w-full gap-4 relative z-10 bg-white/80 border-b-[0.8px] border-[#E7E5E4] shadow-[0_4px_6px_-4px_rgba(0,0,0,0.1),_0_10px_15px_-3px_rgba(0,0,0,0.1)]">
        <div className="flex-1 overflow-hidden sticky top-0 z-20 bg-transparent ">
          <div className="marquee-track">
            <span className="marquee-text whitespace-nowrap">
              {information}
            </span>
          </div>
        </div>

        {/* <p>{information}</p> */}
        <div className="flex flex-col items-end gap-y-1 w-auto shrink-0 z-30 text-[#f2f2f6] font-poppins ">
          <div className="flex relative items-center gap-x-3 text-[16px] text-black ">
            <button
              onClick={() => setIsDropupOpen(!isDropupOpen)}
              className={`flex justify-center items-center gap-x-2 mr-5 text-[#1a1a71] font-semibold rounded-l-md`}
            >
              {selectedLanguageCode}
              <svg
                className={` h-3 w-3 transform transition-transform rotate-180`}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="#102c43"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M10 3a1 1 0 00-.707.293l-7 7a1 1 0 001.414 1.414L10 5.414l6.293 6.293a1 1 0 001.414-1.414l-7-7A1 1 0 0010 3z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            {isDropupOpen && (
              <div className="absolute top-10 right-0 z-30 w-48 bg-white shadow-md border rounded-lg">
                <ul className="flex flex-col py-2">
                  {languages.map((lang) => (
                    <li
                      key={lang.languageCode}
                      className="px-4 py-1.5 hover:bg-gray-400 cursor-pointer flex justify-between items-center"
                      onClick={() => handleHeaderLanguage(lang.languageCode)}
                    >
                      <span>{lang.language}</span>
                      <span className="text-gray-500">{lang.languageCode}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {/* <p>
              Welcome,{" "}
              <span className="font-bold ">{capitalizeFirstLetter(user.name)}</span>
            </p>
            <button onClick={toggleMenu}>
              <Avatar
                src={picLogo || "/broken-image.jpg"}
                sx={{ height: "40px" }}
              />
            </button> */}
          </div>
        </div>
      </div>

      {/* {isOpen && (
        <div
          ref={menuRef}
          className="absolute right-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-10 overflow-hidden"
        >
          <div className="p-4 bg-gradient-to-r from-indigo-500 to-purple-600 text-white text-center">
            <p className="font-semibold">
              Hello, {capitalizeFirstLetter(user.name)}!
            </p>
            <p className="text-sm opacity-80">{user.email}</p>
          </div>
          <ul className="divide-y divide-gray-100">
            <li>
              <button
                onClick={handleSignOut}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Sign Out
              </button>
            </li>
          </ul>
        </div>
      )} */}
    </>
  );
};

export default BotHeader;
